import httpClient from '@/lib/httpClient'
import { useQuery } from '@tanstack/react-query'

export default function useGetMoneyPath({ id }: { id: number | string }) {
  const fetchData = async () => {
    const response = await httpClient.get(`team/money-paths`)
    const rule = response.data.data.find((x) => x.id === Number(id))
    return rule
  }

  return useQuery({
    queryKey: ['money-paths', 'detail', Number(id)],
    queryFn: fetchData,
    enabled: !!id,
  })
}
